import Vue from "vue";
import CustomerSelect from "@/views/Components/CustomerSelect.vue";
import Disposition from "@/views/Components/Disposition.vue";
import LoadingSvg from "@/views/Components/LoadingSvg";
import Vue2PhoneInput from "vue2-simple-phone-input";
import SimpleCalendar from "@/views/Components/SimpleCalendar.vue";
import EditMoney from "@/views/Components/EditMoney.vue";
import { SchedulePlugin } from "@syncfusion/ej2-vue-schedule";
import VueTypeaheadBootstrap from "vue-typeahead-bootstrap";

const Components = (function() {
  var _service;
  function _provision() {
    if (!_service) {
      _service = this;

      Vue.component("customerSelect", CustomerSelect);
      Vue.component("disposition", Disposition);
      Vue.component("simpleCalendar", SimpleCalendar);
      Vue.component("loading-svg", LoadingSvg);
      Vue.component("EditMoney", EditMoney);
      Vue.component("vue-typeahead-bootstrap", VueTypeaheadBootstrap);

      Vue.use(SchedulePlugin);

      Vue.use(Vue2PhoneInput);

      return _service;
    }
    return _service;
  }

  return {
    provision: _provision,
  };
})();
export default Components;
